<template>
  <div id="app">
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      bottom
    >
      <v-list dense>
        <v-list-item v-for="(option,i) in options" @click="selected=option; drawer=false; value=''">
          <v-list-item-action>
            <!-- <v-icon>dashboard</v-icon> -->
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{option.toUpperCase()}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!--         <v-list-item @click="">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Sistema solar - {{selected}}</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex shrink text-center>
            <ka-text :text="value[language]"></ka-text>
            <!-- <ka-video></ka-video> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-footer app>
      <v-row justify="center" no-gutters>
        <v-col class="text-center white--text" cols="12">
           {{ new Date().getFullYear() }} — <strong>Kalliope</strong>          
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</div>
</template>

<script>
import HelloWorld from './components/HelloWorld';
import KaText from './components/KaText.vue'
import KaVideo from './components/KaVideo.vue'

export default {
  name: 'App',

  components: {
    HelloWorld,
    KaText,
    KaVideo
  },

  data: () => ({
    drawer: false,
    type:{
          audio: false,
          video: false,
          text: false,
        },
    server: "wss://mqtt.iglor.es:10443/mqtt",
    client: null,
    topic: "cae716ac7297bc06a33a020cdab085e0/smartphone",
    // topic:"098f6bcd4621d373cade4e832627b4f6/smartphone",
    language: "default",
    value:"",
    options:["Luna","Sol","Tierra","Marte"],
    selected:"",
    filterId: 796
    //"filters":[{"field_id":796,"type":"or","value":["Luna"],"name":"salas"}]

  }),
  mounted(){
    // eslint-disable-next-line no-console
    console.log("connecting")
    this.client = this.$mqtt.connect(this.server,{keepalive:5,rejectUnauthorized: false})
    this.client.on('connect',this.onConnect)
    this.client.on('end',this.onEnd)
    this.client.on('close',this.onClose)
    this.client.on('reconnect',this.onReconnect)
    this.client.on('message',this.onMessage)
  },
  methods:{
    isForMe(action){
      //return true
      if(action.filters != null){        
        if(action.filters.length > 0){
          let filter = action.filters.find((f) => f.field_id == this.filterId)          
          if (filter.value.includes(this.selected))
            return true
        }         
      }
      return false
    },
    onConnect(){
      // eslint-disable-next-line no-console
      console.log("connected")
      this.client.subscribe(this.topic, (err) => {
        if (!err) {
          // eslint-disable-next-line no-console
          console.log("Subscription OK")
        }else{
          // eslint-disable-next-line no-console
          console.log("Subscription error",error)
        }
      })
    },
    onMessage(topic,message){
      let action = JSON.parse(message.toString()).action
      if (this.isForMe(action)){
        // eslint-disable-next-line no-console
        console.log("is for me")
        let keys = Object.keys(this.type)
        keys.forEach((k) => {        
          if (action.value == k)
            this.type[k]  = true
          else 
            this.type[k]  = false        
        })
        this.value = action.data.file
      }
      // eslint-disable-next-line no-console
      console.log("Message received",topic,message,action)
    },
    onEnd(){

    },
    onClose(){

    },
    onReconnect(){

    },

  }
};
</script>
